import * as types from '../types'

/**
 * 食谱数据
 * @type {Object}
 */
const state = {
    list: [],
    detail: {
        recipe: {
            major: '',
            minor: ''
        },
        steps: []
    }
}

const getters = {

}

const mutations = {
    [types.INIT_RECIPE_LIST] (state, arr) {
        state.list = arr
    },

    [types.AJAX_UPDATE_RECIPE_LIST] (state, arr) {
        state.list = state.list.concat(arr)
    },

    [types.INIT_RECIPE_DETAIL] (state, params) {
        state.detail = params
    }
}

const actions = {

}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/rscipe.js